<template>
  <div class="asc-anser-signature-template-container">
    <AscSignatureEmbedded :plotly-data="getSignatureData" />
  </div>
</template>

<script>
import AscSignatureEmbedded from '../molecules/AscSignatureEmbedded.vue'

export default {
  name: 'AscAnserSignatureTemplate',

  components: {
    AscSignatureEmbedded,
  },

  props: {
    plotlyData: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    getSignatureData() {
      if (Object.prototype.hasOwnProperty.call(this.plotlyData, 'ANSER')) {
        return this.plotlyData['ANSER']
      }
      return null
    },
  },
}
</script>
